import { useRef, useState } from 'react';
import LucideIcon from '../lucide-icon';

export default function CopyText({
  text,
  required = false,
  value,
  dateFormat,
}) {
  const [hovered, setHovered] = useState(false);
  const [copied, setCopied] = useState(false);
  const textRef = useRef(null);
  async function handleCopy() {
    try {
      let textToCopy;

      if (value && value instanceof Date) {
        if (dateFormat) {
          const options = {};
          if (dateFormat.includes('DD')) options.day = '2-digit';
          if (dateFormat.includes('MM')) options.month = '2-digit';
          if (dateFormat.includes('YYYY')) options.year = 'numeric';
          textToCopy = value.toLocaleDateString('pt-BR', options);
        } else {
          textToCopy = value.toLocaleDateString('pt-BR');
        }
      } else if (
        value &&
        (typeof value === 'string' ||
          typeof value === 'number' ||
          typeof value === 'boolean')
      ) {
        textToCopy = String(value);
      } else if (value && Array.isArray(value)) {
        textToCopy = value
          .map((item) => item.nome ?? item.descricao)
          .join(', ');
      } else if (
        value &&
        typeof value === 'object' &&
        ('nome' in value || 'descricao' in value)
      ) {
        textToCopy = value.nome ?? value.descricao;
      } else if (
        text &&
        (typeof text === 'string' ||
          typeof text === 'number' ||
          typeof text === 'boolean')
      ) {
        textToCopy = String(text);
      } else {
        textToCopy = textRef.current?.textContent;
      }

      await navigator.clipboard.writeText(textToCopy);
      setCopied(true);
      setTimeout(() => setCopied(false), 1500);
    } catch (e) {}
  }

  return (
    <span
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
      onFocus={() => setHovered(true)}
      onBlur={() => setHovered(false)}
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: 4,
        lineHeight: 1.2,
      }}
    >
      <span ref={textRef}>{text}</span>
      <span>{required ? '*' : ''}</span>

      {(hovered || copied) && (
        <button
          type="button"
          onClick={handleCopy}
          style={{
            display: 'inline-flex',
            alignItems: 'center',
            justifyContent: 'center',
            border: 'none',
            background: 'transparent',
            padding: 0,
            margin: 0,
            cursor: 'pointer',
            verticalAlign: 'middle',
            width: 18,
            height: 18,
          }}
        >
          {copied ? (
            <LucideIcon icon="Check" size={14} color="green" />
          ) : (
            <LucideIcon icon="Copy" size={14} color="#555" />
          )}
        </button>
      )}
    </span>
  );
}
